import React, { Component } from 'react';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, ContentState, convertToRaw, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';

//https://www.youtube.com/watch?v=dYLNg1BWwFo
//https://github.com/jpuri/react-draft-wysiwyg
//https://jpuri.github.io/react-draft-wysiwyg/#/demo

export class TextEditor extends Component {
  constructor(props) {
    super(props);
    // Inicializa o estado com a prop ou vazio
    const content = props.initialValue 
      ? ContentState.createFromBlockArray(convertFromHTML(props.initialValue))
      : ContentState.createFromBlockArray(convertFromHTML(sessionStorage.getItem('corpoEmail') || '<p>Texto padrão 2</p>'));//createEmpty();
    this.state = { editorState: EditorState.createWithContent(content) };
  }

  // state = {
  //   editorState: EditorState.createEmpty(),
  // }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
    const htmlContent = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    if (this.props.onChange) {
      this.props.onChange({ target: { name: this.props.name, value: htmlContent } });
    }
    return htmlContent;
  };

  //const { editorState } = this.state;

  render() {
    const { editorState } = this.state;
    return (
      <div>
        <Editor
          editorState={editorState} 
          toolbar={{
              options: 
              [
                'inline', 
                'blockType', 
                'fontSize', 
                'list', 
                'textAlign', 
                'colorPicker', 
                'link', 
                'embedded', 
                'emoji', 
                'image'
              ],
              link: { 
                defaultTargetOption: '_blank',
                inDropDown: false,
                showOpenOptionOnHover: true,
                options: ['link', 'unlink'],
              },
              'colors': { 
                'options': ['black', 'red', 'orange', 'yellow', 'green', 'blue', 'indigo', 'violet']
              },
              image : {
                previewImage: true,
                alt: { present: true, mandatory: false },
                defaultSize: {
                  height: '300px',
                  width: '300px',
                },
                inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
              },
              fontFamily: {
                options: 
                [
                  'Arial', 
                  'Georgia', 
                  'Impact', 
                  'Tahoma', 
                  'Times New Roman', 
                  'Verdana'
                ],
              },
              fontSize: {
                options: [8, 10, 12, 14, 16, 18, 24, 30, 36, 48],
              }
            }}
          toolbarClassName="demo-toolbar" 
          toolbarStyle={{color: '#000'}}
          wrapperClassName="demo-wrapper"
          editorClassName="demo-editor"
          editorStyle={{ minHeight: '200px', color: 'black', backgroundColor: '#fff', padding: '10px'}}
          onEditorStateChange={this.onEditorStateChange} 
        />
        <textarea style={{marginTop: '20px', width: '100%', height: '40px'}}
          value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
        />
      </div>
    );
  }
}